"use client";

import Image, { StaticImageData } from "next/image";
import { useEffect, useRef, useState } from "react";

type LazyShowcaseVideoProps = {
  poster: StaticImageData;
  src: string;
};

export default function LazyShowcaseVideo({
  poster,
  src,
}: LazyShowcaseVideoProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);

  useEffect(() => {
    const node = containerRef.current;

    if (!node || shouldLoadVideo) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoadVideo(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: "200px 0px",
      }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [shouldLoadVideo]);

  return (
    <div ref={containerRef} className="relative h-full w-full">
      {shouldLoadVideo ? (
        <video
          className="h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="none"
          poster={poster.src}
        >
          <source src={src} type="video/mp4" />
          Tu navegador no soporta videos.
        </video>
      ) : (
        <Image
          src={poster}
          alt="Vista previa de un mapa estelar personalizado"
          fill
          sizes="(max-width: 768px) 90vw, 40vw"
          className="object-cover"
        />
      )}
    </div>
  );
}
